import React, { useCallback, useRef, useState, useEffect } from 'react';
import { withStyles, Typography, Tooltip, IconButton, Dialog, DialogTitle, Grid, } from '@material-ui/core';
import { connect } from 'react-redux';
import OrderList from './OrderList';
import { hasPermission, createHistory, hasAtLeastOnePermission, parseURL } from '../../sc-utilities';
import { FindInPage, LibraryBooks, LibraryBooksTwoTone, Storage, Dvr, DevicesOther, SdCard, CloudUpload, AllInbox, Headset, Watch } from '@material-ui/icons';
import { Redirect } from 'react-router-dom';
import * as actions from './store/orderActions';
import * as groupActions from "../../sc-group/Group/store/groupActions";
import * as pcActions from '../../sc-product/PCProduct/store/pcProductActions';
import AppLogoLoading from "../../sc-logo";
import { getGroupsLookup } from '../../sc-dashboard/ProductOverview/ProductsAll';
import { checkIfLoading } from "../../sc-users/User";
import ExportForm from '../../sc-components/ExportForm/ExportForm';
import ConfirmationDialog from '../../np-components/ConfirmationDialog/ConfirmationDialog';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            color: theme.palette.success.dark
        },
        "[class*='statusInactive']": {
            color: theme.palette.error.dark
        },
        "[class*='button']": {
            textTransform: 'none',
            textDecoration: 'none'
        }
    },
    button: {
        textTransform: 'none',
        textDecoration: 'none'
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    },
    loading: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    }
});

let initialValues = [
    'Excel',
    'JSON',
    'CSV',
    'XML',
    'Download',
    "Email",
    "includePDFReports",
    "includeDiagnoseReports",
    "includeVerificationReports",
    "includeAggregatedPDFErasureReports",
    "includeAggregatedPDFVerificationReports",
    "includeSummaryPDFErasureReports",
    "includeSummaryPDFVerificationReports",
];

const Order = props => {
    const tableRef = useRef();
    const { classes, translations, permissions, activeExternalServiceAvailable, columns, activeCustomerID, onBulkGenerateReports, fetchGroups, onSendExternalData, onSendErasureReports } = props;
    let visible = columns && columns['Order'];
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, OrderID: null, redirectPath: "", search: '' });
    const [groups, setGroups] = useState(null);
    const [loading, setLoading] = useState({ groups: false });
    const [collectionCreatePopupIsOpen, setCollectionCreatePopupIsOpen] = useState(false);
    const [rowData, setRowData] = useState(null)
    const [confirmDialog, setConfirmDialog] = useState({ open: false, confirmed: false, type: '', title: '' });

    const handleOpenDialog = (rowData, type, title) => {
        setConfirmDialog({ open: true, type, title });
        setRowData(rowData);  
    };

    const defaultFilter = parseURL(window.location.search);

    const formSettings = {
        Validation: {},
        FormTitle: translations["create_collection"] || "Create collection",
        ButtonSubmit: {
            Title: translations["download"] || "Download",
            Color: 'primary'
        },
        InitialValues: { GroupID: groups?.map(group => group.value)?.includes('n/a') ? 'n/a' : groups?.[0]?.value ?? null }
    };

    useEffect(() => {
        const getGroups = async () => {
            setLoading(prevState => { return { ...prevState, groups: true } });
            const resultGroups = await fetchGroups({ ActiveCustomerID: activeCustomerID });
            if (resultGroups) {
                setGroups(resultGroups.data);
            }
            setLoading(prevState => { return { ...prevState, groups: false } });
        }

        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        // eslint-disable-next-line
    }, []);

    const groupsLookup = getGroupsLookup(groups, translations, permissions);

    const sendExternalData = useCallback(async (orderID) => {
        await onSendExternalData({ OrderID: orderID, ActiveCustomerID: activeCustomerID })
    }, [activeCustomerID, onSendExternalData]);

    const sendErasureReports = useCallback(async (orderID) => {
        await onSendErasureReports({ OrderID: orderID, ActiveCustomerID: activeCustomerID })
    }, [activeCustomerID, onSendErasureReports]);

    useEffect(() => {
        if (confirmDialog.confirmed) {
            if (confirmDialog.type === 'data') {
                sendExternalData(rowData.OrderID);
            } else if (confirmDialog.type === 'report') {
                sendErasureReports(rowData.OrderID);
            }
        }
    }, [confirmDialog.confirmed, confirmDialog.type, rowData?.OrderID, sendExternalData, sendErasureReports]);

    const tableActionsRow = [
        {
            icon: 'FindInPage',
            tooltip: translations["order_details"] || "Order details",
            onClick: (event, rowData) => goToOrderDetails(event, rowData),

            hidden: !hasPermission(permissions, "order_load")
        },
        {
            icon: 'Storage',
            hidden: !hasPermission(permissions, "transport_colli_list"),
            tooltip: translations["go_to_transport_collies"] || "Go to transport collies",
            onClick: (event, rowData) => goToTransportCollies(event, rowData),
        },
        {
            icon: 'Dvr',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_pc_products"] || "Go to PC products",
            onClick: (event, rowData) => goToPCProducts(event, rowData),
        },
        {
            icon: 'DevicesOther',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_mobile_products"] || "Go to mobile products",
            onClick: (event, rowData) => goToMobileProducts(event, rowData),
        },
        {
            icon: 'SdCard',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_storage_products"] || "Go to storage products",
            onClick: (event, rowData) => goToStorageProducts(event, rowData),
        },
        {
            icon: 'Headphone',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_headphone_products"] || "Go to headphone products",
            onClick: (event, rowData) => goToHeadphoneProducts(event, rowData),
        },
        {
            icon: 'Watch',
            hidden: !hasPermission(permissions, "product_list"),
            tooltip: translations["go_to_watch_products"] || "Go to watch products",
            onClick: (event, rowData) => goToWatchProducts(event, rowData),
        },
        {
            icon: 'LibraryBooks',
            hidden: !hasPermission(permissions, "order_generate_report"),
            tooltip: translations["create_collection"] || "Create collection",
            onClick: (event, rowData) => { 
                setRowData(rowData);  
                setCollectionCreatePopupIsOpen(true);}
        },
        {
            icon: 'CloudUpload',
            tooltip: translations['send_external_data'] || "Send external data",
            onClick: (event, rowData) => handleOpenDialog(rowData, 'data', translations['sure_want_to_resend_data_for_order'] || `Are you sure you want to re-send data for the whole Order?`),
            hidden: !hasPermission(permissions, 'product_send_external_data')
        },
        {
            icon: 'AllInbox',
            tooltip: translations['send_erasure_reports'] || "Send erasure reports",
            onClick: (event, rowData) => handleOpenDialog(rowData, 'report', translations['sure_want_to_resend_reports_for_order'] || `Are you sure you want to re-send erasure reports for the whole Order?`),
            hidden: !hasPermission(permissions, 'product_send_erasure_report')
        },
    ]

    const getIcon = icon => {
        switch (icon) {
            case 'FindInPage':
                return <FindInPage />
            case 'LibraryBooks':
                return <LibraryBooks />
            case 'LibraryBooksTwoTone':
                return <LibraryBooksTwoTone />
            case 'Storage':
                return <Storage />
            case 'Dvr':
                return <Dvr />
            case 'DevicesOther':
                return <DevicesOther />
            case 'SdCard':
                return <SdCard />
            case 'CloudUpload':
                return <CloudUpload />
            case 'AllInbox':
                return <AllInbox />
            case 'Headphone':
                return <Headset />
            case 'Watch':
                return <Watch />
            default:
                return <SdCard />
        }
    };

    const typeSwitch = (param) => {
        switch (param) {
            case 'pickup':
                return translations["pickup"] || 'Pickup';
            case 'delivery':
                return translations["delivery"] || 'Delivery';
            default:
                return translations['short_not_assigned'] || 'n/a';
        }
    }
    const statusSwitch = (param) => {
        switch (param) {
            case 'new':
                return translations["new"] || 'New';
            case 'scheduled':
                return translations["scheduled"] || 'Scheduled';
            case 'on_hold':
                return translations["on_hold"] || 'On Hold';
            case 'in_warehouse':
                return translations["in_warehouse"] || 'In Warehouse';
            case 'finished':
                return translations["finished"] || 'Finished';
            default:
                return translations['short_not_assigned'] || 'n/a';
        }
    };

    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 240, maxWidth: 240 },
            filtering: false,
            render: rowData => {
                return tableActionsRow.map(action => {
                    if (action.hidden) {
                        return null;
                    }
                    return (
                        <Tooltip key={`${action.icon}-${rowData.OrderID}`} title={action.tooltip}>
                            <IconButton
                                component='div'
                                onClick={(event) => action.onClick(event, rowData)}
                            >
                                {
                                    getIcon(action.icon)
                                }
                            </IconButton>
                        </Tooltip>
                    )
                })
            },
        },
        {
            title: translations["id"] || "ID", field: 'OrderInventoryID',
            customSort: () => { },
            defaultSort: 'desc',
            hidden: visible ? visible['OrderInventoryID'] : false,
            defaultFilter: `${defaultFilter && defaultFilter.OrderInventoryID ? defaultFilter.OrderInventoryID : ''}`,
            cellStyle: {
                width: 80,
                minWidth: 80
            },
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.OrderInventoryID ? rowData.OrderInventoryID : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations["external_id"] || "External ID", field: 'ExternalID',
            hidden: visible ? visible['ExternalID'] : false,
            cellStyle: {
                width: 130,
                minWidth: 130
            },
            customSort: () => { },
            sorting: false,
            render: rowData => {
                if (rowData.PaletteExternalInfo) {
                    return rowData.PaletteExternalInfo.map((externalInfo, index) => {
                        if (externalInfo.ExternalID) {
                            return (<Typography key={`${externalInfo.ExternalServiceType}_${externalInfo.ExternalID}_${index}`} variant={'caption'}>{`${externalInfo.ExternalServiceType} - ${externalInfo.ExternalID}`}<br /></Typography>)
                        }
                        return <Typography key={`${externalInfo.ExternalServiceType}_${externalInfo.ExternalID}_${index}`} variant={'caption'}>n/a<br /> </Typography>;
                    })
                }
                return <Typography variant={'caption'}>n/a</Typography>;
            },
        },
        {
            title: translations["name"] || "Name", field: 'Name',
            hidden: visible ? visible['Name'] : false,
            customSort: () => { },
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            },
        },
        {
            title: translations["description"] || 'Description', field: 'Description',
            hidden: visible ? visible['Description'] : false,
            customSort: () => { },
            render: rowData => {
                return <> {rowData.Description && rowData.Description.length > 15 ?
                    <Tooltip key={`${rowData.Description}-${rowData.OrderID}`} title={rowData.Description}>
                        <Typography variant={'caption'}>{rowData.Description.slice(0, 14)}</Typography>
                    </Tooltip>
                    : <Typography variant={'caption'}>{rowData.Description ? rowData.Description : translations['short_not_assigned'] || 'n/a'}</Typography>}</>
            },
        },
        {
            title: translations["report_information"] || 'Report information', field: 'ReportInformationName',
            hidden: visible ? visible['ReportInformationName'] : false,
            customSort: () => { },
            render: rowData => {
                return <Typography variant={'caption'}>  {rowData.ReportInformation ? rowData.ReportInformation.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["file_pattern"] || 'File pattern', field: 'FilePattern',
            hidden: visible ? visible['FilePattern'] : false,
            customSort: () => { },
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.FilePattern && rowData.FilePattern.Name ? rowData.FilePattern.Name : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["group"] || 'Group', field: 'GroupID',
            cellStyle: { minWidth: 100, maxWidth: 100 },
            hidden: visible ? visible['GroupID'] : false,
            lookup: groupsLookup,
            defaultFilter: defaultFilter?.GroupID ? [defaultFilter.GroupID] : groups ? Object.keys(groupsLookup) : [],
            render: rowData => {
                return <Typography style={{ fontSize: 12 }} gutterBottom>{rowData?.Group ? rowData.Group?.Name : (translations['short_not_assigned'] || 'n/a')}</Typography>
            }
        },
        {
            title: translations["signature"] || 'Signature', field: 'ErasureReportSignature',
            customSort: () => { },
            hidden: visible ? visible['ErasureReportSignature'] : false,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0', '1'],
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ErasureReportSignature ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            customSort: () => { },
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0'],
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        },
        {
            title: translations["type"] || 'Type', field: 'Type',
            hidden: visible ? visible['Type'] : false,
            customSort: () => { },
            lookup: { 'pickup': translations['pickup'] || 'Pickup', 'delivery': translations['delivery'] || 'Delivery' },
            defaultFilter: ['pickup', 'delivery'],
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{typeSwitch(rowData?.Type) || translations[rowData.Type]}</Typography>;
            }
        },
        {
            title: translations["status"] || 'Status', field: 'Status',
            hidden: visible ? visible['Status'] : false,
            customSort: () => { },
            lookup: { 'new': translations['new'] || 'New', 'scheduled': translations['scheduled'] || 'Scheduled', 'in_warehouse': translations['in_warehouse'] || 'In Warehouse', 'on_hold': translations['on_hold'] || 'On Hold', 'finished': translations['finished'] || 'Finished' },
            defaultFilter: ['new', 'scheduled', 'in_warehouse', 'on_hold', 'finished'],
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{statusSwitch(rowData?.Status) || translations[rowData.Status]}</Typography>;
            }
        },
    ];

    const goToTransportCollies = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, orderID: rowData.OrderInventoryID, redirectPath: `/logistic/transport-container`, search: `OrderInventoryID=${rowData.OrderInventoryID}` });
    };

    const goToPCProducts = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, orderID: rowData.OrderInventoryID, redirectPath: `/products/pc-products`, search: `OrderInventoryID=${rowData.OrderInventoryID}` });
    };

    const goToMobileProducts = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, orderID: rowData.OrderInventoryID, redirectPath: `/products/mobile-products`, search: `OrderInventoryID=${rowData.OrderInventoryID}` });
    };

    const goToStorageProducts = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, orderID: rowData.OrderInventoryID, redirectPath: `/products/storage-products`, search: `OrderInventoryID=${rowData.OrderInventoryID}` });
    };

    const goToHeadphoneProducts = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, orderID: rowData.OrderInventoryID, redirectPath: `/products/headphone-products`, search: `OrderInventoryID=${rowData.OrderInventoryID}` });
    };

    const goToWatchProducts = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, orderID: rowData.OrderInventoryID, redirectPath: `/products/watch-products`, search: `OrderInventoryID=${rowData.OrderInventoryID}` });
    };

    const goToOrderDetails = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, OrderID: rowData.OrderID, redirectPath: `/order/details`, search: `OrderID=${rowData.OrderID}` });
    };

    const goToDeleteOrder = orderIDS => {
        createHistory();
        setRedirectOptions({ redirect: true, OrderID: orderIDS, redirectPath: `/order/delete`, search: '' });
    };

    const generateBulkErasureReports = useCallback(async (formData) => {
        const exportFormatKeys = Object.keys(formData).filter(key => ["Excel", "JSON", "XML", "CSV"].includes(key));
        const exportFormats = [];
        for (const key of exportFormatKeys) {
            if (formData[key]) {
                const exportFormat = {};
                switch (key) {
                    case "Excel":
                        exportFormat.xlsx = { individualAssets: !!formData?.individualExcelReports };
                        break;
                    case "JSON":
                        exportFormat.json = { individualAssets: !!formData?.individualJsonReports };
                        break;
                    case "XML":
                        exportFormat.xml = { individualAssets: !!formData?.individualXmlReports };
                        break;
                    case "CSV":
                        exportFormat.csv = { individualAssets: !!formData?.individualCsvReports };
                        break;
                }
                exportFormats.push(exportFormat);
            }
        }

        const outputModes = Object.keys(formData).filter(key => ["Download", "Email"].includes(key)).filter((key) => formData[key]);

        const dataToSend = {
            ActiveCustomerID: activeCustomerID,
            CollectionType: 'order_collection',
            ExportFormats: exportFormats,
            OutputModes: outputModes.map(item => item.toLowerCase()),
            includePDFReports: formData.includePDFReports,
            includeAggregatedPDFErasureReports: formData.includeAggregatedPDFErasureReports,
            includeAggregatedPDFVerificationReports: formData.includeAggregatedPDFVerificationReports,
            includeSummaryPDFErasureReports: formData.includeSummaryPDFErasureReports,
            includeSummaryPDFVerificationReports: formData.includeSummaryPDFVerificationReports,
            includeDiagnoseReports: formData.includeDiagnoseReports,
            includeVerificationReports: formData.includeVerificationReports,
            GroupID: formData.GroupID,
            generateNew: formData.generateNew,
            CollectionTypeID: rowData.OrderID,     
        }
        await onBulkGenerateReports(dataToSend, translations);
        setCollectionCreatePopupIsOpen(false)
    }, [activeCustomerID, onBulkGenerateReports, rowData]);

    const goToCreateOrder = () => {
        createHistory();
        setRedirectOptions({ redirect: true, OrderID: null, redirectPath: `/order/create` });
    };

    if (redirectOptions.redirect) {
        return <Redirect to={{
            pathname: redirectOptions.redirectPath,
            search: redirectOptions.search,
            state: { OrderID: redirectOptions.OrderID }
        }} />;
    }

    if (!hasAtLeastOnePermission(permissions, [
        "order_load",
        "order_generate_report",
        "order_delete",
        "product_list",
        "transport_colli_list"
    ])) {
        tableColumns.shift();
    }

    if (!activeExternalServiceAvailable) {
        if (tableColumns[0].field === 'Action') {
            tableColumns.splice(2, 1);
        } else {
            tableColumns.splice(1, 1);
        }
    }

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{ classes: { root: classes.loading } }}>
        <AppLogoLoading />
    </Dialog>;

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'order_list') ?
                loading.groups ? loadingScreen :
                    <OrderList goToCreateOrder={goToCreateOrder} goToDeleteOrder={goToDeleteOrder} tableColumns={tableColumns} tableRef={tableRef} groups={groups} />
                : null
            }
            {
                <>
                    <Dialog classes={{ paper: classes.dialogPaper }} onClose={() => setCollectionCreatePopupIsOpen(false)} aria-labelledby="customized-dialog-title" open={collectionCreatePopupIsOpen} fullWidth={true}
                        maxWidth={'md'} >
                        <DialogTitle className={classes.title}>{`${translations["create_collection"] || "Create collection"}`} </DialogTitle>
                        <Grid container >
                            <Grid item xs={12}>
                                <ExportForm
                                    setIsOpen={collectionCreatePopupIsOpen}
                                    initialValues={initialValues}
                                    formSettings={formSettings}
                                    translations={translations}
                                    handleDownload={generateBulkErasureReports}
                                    groups={groupsLookup ? Object.keys(groupsLookup).map(key => ({ value: key, displayValue: groupsLookup[key] })) : []}
                                    showProductOverviewExportTypes={true}
                                    showProductOverviewOutputMode={true}
                                />
                            </Grid>
                        </Grid>
                    </Dialog>
                    {confirmDialog.open && <ConfirmationDialog
                        isOpen={confirmDialog.open}
                        title={confirmDialog.title}
                        contentText={translations['it_could_slow_down_live_message_sending'] || `It could slow down the sending of "live" messages to external systems.`}
                        onYes={() => setConfirmDialog({ open: false, confirmed: true, type: confirmDialog.type })}
                        onCancel={() => setConfirmDialog({ open: false, confirmed: false, type: confirmDialog.type })}
                        textCancel={translations['cancel'] || 'Cancel'}
                        textYes={translations['send'] || 'Send'}
                    />}
                </>
            }
        </div>
    );
}

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onBulkGenerateReports: (data, translations) => dispatch(actions.generateReports(data, translations)),
        fetchGroups: params => dispatch(groupActions.fetchGroups(params)),
        onSendExternalData: params => dispatch(pcActions.sendExternalData(params)),
        onSendErasureReports: params => dispatch(pcActions.sendErasureReports(params)),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(Order));